"use client";
import { ArrowDropDown as MenuIcon } from "@mui/icons-material";

import { useStore, observer } from "../../../service/mobx";
import ChipFilter from ".";

export default function ChipFilterMenu({
  param,
  disabled,
  label,
  selected,
  StartIcon,
  Menu = {},
  small
}) {
  const { menu } = useStore();
  const anchorId = `menu-${param}`;

  return (
    <ChipFilter
      id={anchorId}
      small={small}
      label={label}
      disabled={disabled}
      selected={selected}
      StartIcon={StartIcon}
      EndIcon={EndIcon}
      onClick={() =>
        menu.configure({ anchorId, ...Menu, state: { key: label } })
      }
      sx={{ borderRadius: theme => theme.shape.round }}
    />
  );
}

const EndIcon = observer(function EndIcon({ sx, label }) {
  const { menu } = useStore();

  return (
    <MenuIcon
      sx={{
        ...sx,
        transform:
          menu.open && menu.state?.key === label ? "rotate(180deg)" : undefined,
        transition: theme =>
          theme.transitions.create("transform", {
            easing: theme.motion.easing.standard,
            duration: theme.motion.duration.short[4]
          })
      }}
    />
  );
});
